<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  components: {},
  props: {
    itemRef: {
      type: String,
      default: 'checkbox',
    },
    modelValue: {
      type: Array,
      default: () => {},
    },
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    itemIndex: {
      type: [Number, String],
      required: false,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    value: {
      type: [Number, String],
      required: false,
      default: null,
    },
    keepSameLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value);
      } else {
        return this.modelValue === this.value;
      }
    },
    val() {
      return this.keepSameLabel
        ? this.item.label ||
            this.item.text ||
            this.item.name ||
            this.item.type ||
            this.id ||
            this._id
        : (
            this.item.label ||
            this.item.text ||
            this.item.name ||
            this.item.type ||
            this._id ||
            this.id
          ).toLowerCase();
    },
  },
  mounted() {},
  methods: {
    updateInput(event) {
      const isChecked = event.target.checked;
      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue];
        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }
        this.$emit('change', newValue);
      } else {
        this.$emit('change', isChecked);
      }
    },
  },
};
</script>

<template>
  <div class="base-checkbox">
    <label :for="`${itemRef}_${itemIndex}`">
      <input
        type="checkbox"
        :value="value"
        :checked="isChecked"
        :id="`${itemRef}_${itemIndex}`"
        @change="updateInput"
        v-bind="$attrs"
        :disabled="isDisabled"
      />
      <span :class="isDisabled ? 'checkbox disabled' : 'checkbox'"></span>
    </label>
    <span class="checkbox-title">{{ val }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-max-type

label {
  position: relative;
}

.base-checkbox {
  display: inline-flex;
  justify-content: center;
  margin-bottom: 0.5rem;

  label {
    margin-bottom: 0.2rem;
  }

  .checkbox {
    background-color: $color-light-gray;
    border-radius: 10%;
    cursor: pointer;
    display: inline-block;
    height: 14px;
    transition: all linear 0.3s;
    width: 14px;

    &.disabled {
      cursor: default;
    }

    &::after {
      border-bottom: 2px solid white;
      border-right: 2px solid white;
      content: '';
      height: 9px;
      left: 5px;
      opacity: 0.6;
      position: absolute;
      top: 2.5px;
      transform: rotate(45deg);
      visibility: hidden;
      width: 5px;
    }
  }

  input {
    display: none;

    &:checked ~ .checkbox {
      background: $color-action;
      border: unset;

      &::after {
        visibility: visible;
      }
    }
  }

  .checkbox-title {
    font-family: $base-font-family;
    font-size: 1.2rem;
    font-weight: 900;
    letter-spacing: 0.2px;
    line-height: 2rem;
    margin-left: 7px;
    text-transform: capitalize;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}
</style>
